import BasicLayout from '@/layouts/basic-layout';
////第一步：配置菜单-->第二步：配置存房委托指派商家页面相关的路由-->第三步：注入路由-->第四步：做页面
const meta = {
	auth: true
};

const pre = 'rentmanage-rentHouse';

export default {
	path: '/rentmanage/renthousechannel/index',
	name: '房源出租(渠道)',//存房委托指派专员
	redirect: {
		name: `${pre}rentHouse-channel-list`
	},
	meta,
	component: BasicLayout,
	children: [{
		path: 'rentHouse-channel-list',
		name: `${pre}rentHouse-channel-list`,
		meta: {
			...meta,
			title: '房源出租(渠道)',
			closable: true
		},
		component: () => import('@/pages/rentmanage/renthousechannel/index')
	}]
};
